export { default } from './TimeTargetTaskInputs';



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/TimeTargetTaskInputs/index.js